import ProductCard from "./ProductCard";
import productsData from "../data/products.json";

export default function ProductGrid() {
  // Get all products from all category arrays
  const allProducts = [
    ...productsData.mobiles,
    ...productsData.leds,
    ...productsData.homeAppliances,
    ...productsData.watches,
    ...productsData.audio,
    ...productsData.tablets,
    ...productsData.earbuds,
    ...productsData.soundbars,
    ...productsData.projectors
  ];

  // Get first 6 products as featured
  const products = allProducts.slice(0, 6);

  return (
    <div className="products-grid">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
